import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import '../Checklist/index.css';
import './index.css';
import { Modal } from 'react-bootstrap';


const FillInventoryModal = ({ key, isVisible, inventory, onChange, onClose }) => {

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      width: '50%',
      transform: 'translate(-50%, -50%)',
      padding: '5px 10px 10px',
      maxHeight: '550px',
      minHeight: '200px',
    },
  };

  const customSelectStyles = {
    input: () => ({
      height: '24px',
    }),
  };

  const DaysOptions = [...Array(30)].map((a, b) => ({
    label: b + 1,
    value: b + 1,
  }));

  const [attributes, setAttributes] = useState(inventory?.inventory_attributes || []);
  const [pricing, setPricing] = useState([
    {
      days: null,
      price: '',
    },
  ]);

  useEffect(() => {
    if (inventory?.pricing && inventory?.pricing?.length) {
      setPricing(inventory?.pricing);
    }
  }, []);

  const onAddPricingClick = () => {
    let price = [...pricing];
    setPricing([...price, {}]);
  };

  const onSubmit = () => {
    const newInventory = Object.assign({}, inventory, {
      inventory_attributes: attributes,
      pricing: pricing.filter((item) => item.days),
    });

    onChange(newInventory);

    // Close modal on submit
    onClose();
  };

  const handleAttributeChange = (attribute, index) => {
    let attributes = [...attribute];
    attributes[index] = { ...attributes };
    setAttributes(attributes);
  };

  const renderAttributeRow = (attribute, index) => {
    if (attribute.isChecked === false) {
      return;
    }

    if (
      attribute.type === 'SUPPLIER_TYPE' ||
      attribute.type === 'BASE_SUPPLIER_TYPE' ||
      attribute.type === 'INVENTORY_TYPE'
    ) {
      return;
    }

    return (
      <div className="createform__form__row" key={attribute?.name}>
        <div className="createform__form__inline supplier-modal-input">
          <div className="form-control">
            <input type="text" value={attribute?.name} disabled />
          </div>

          <div className="form-control">{renderAttributeInput(attribute, index)}</div>
        </div>
      </div>
    );
  };

  const renderPricingRow = (row, index) => {
    const onDaysChange = (day) => {
      let price = [...pricing];
      price[index] = {
        ...price[index],
        days: day.value,
      };
      setPricing(price);
    };

    const onPriceChange = (event) => {
      let prices = [...pricing];
      prices[index] = {
        ...prices[index],
        price: event.target.value,
      };
      setPricing(prices);
    };

    const onRemove = () => {
      let prices = [...pricing];
      prices.splice(index, 1);
      setPricing(prices);
    };

    return (
      <div className="createform__form__inline supplier-modal-input" key={index}>
        <div className="form-control">
          <Select
            options={DaysOptions}
            value={DaysOptions.filter(({ value }) => value === row.days)}
            onChange={onDaysChange}
            classNamePrefix="form-select"
          />
        </div>
        <div className="form-control">
          <input type="number" placeholder="Price" value={row.price} onChange={onPriceChange} />
        </div>
        {''}
        {pricing.length > 1 ? (
          <button type="button" className="btn btn--link" onClick={onRemove}>
            &times;
          </button>
        ) : null}
      </div>
    );
  };

  const renderAttributeInput = (attribute, attrIndex) => {
    const onValueChange = (event) => {
      const newAttribute = Object.assign({}, attribute);

      if (event.target.type === 'number') {
        newAttribute.value = parseFloat(event.target.value);
      } else {
        newAttribute.value = event.target.value;
      }

      handleAttributeChange(newAttribute, attrIndex);
    };

    const onDropDownAttributeValueChange = (newValue) => {
      const newAttribute = Object.assign({}, attribute);

      newAttribute.value = newValue.value;

      handleAttributeChange(newAttribute, attrIndex);
    };

    switch (attribute.type) {
      case 'FLOAT':
        return (
          <input
            type="number"
            placeholder="Attribute Value"
            value={attribute.value}
            onChange={onValueChange}
          />
        );
      case 'STRING':
        return (
          <input
            type="text"
            placeholder="Attribute Value"
            value={attribute.value}
            onChange={onValueChange}
          />
        );
      case 'EMAIL':
        return (
          <input
            type="email"
            placeholder="Attribute Value"
            value={attribute.value}
            onChange={onValueChange}
          />
        );
      case 'DROPDOWN':
        let attributeValueOptions = [];
        attribute.options.forEach((option) => {
          attributeValueOptions.push({ label: option, value: option });
        });
        return (
          <Select
            styles={customSelectStyles}
            options={attributeValueOptions}
            value={{ label: attribute.value, value: attribute.value }}
            onChange={onDropDownAttributeValueChange}
          />
        );
      default:
        return;
    }
  };

  return (
    <Modal
      show={isVisible}
      onHide={onClose}
      className={'theme-modal'}
      style={customStyles}
      id={''}
      size={'md'}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h3>Fill Attributes for Inventory</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="createform__form">
          <div className="title">Inventory: {inventory?.name}</div>
        </div>
        <div className="createform__form">{attributes.map(renderAttributeRow)}</div>
        <div className="createform__form">
          <div className="title">Add Pricing Details</div>
          {pricing.map(renderPricingRow)}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-footer">
          <button type="button" className="btn btn--danger" onClick={onAddPricingClick}>
            Add Pricing
          </button>{' '}
          <button type="button" className="btn btn--danger" onClick={onSubmit}>
            Submit
          </button>{' '}
          <button type="button" className="btn btn--danger" onClick={onClose}>
            Close
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
export default FillInventoryModal;
